import { Component, OnInit } from '@angular/core';
import { Schedule } from '../model/schedule';
import * as moment from 'moment';
import { ScheduleService } from '../services/schedule.service';
import { SettingsService } from '../services/settings.service';
import { DispatcherService } from '../services/dispatcher.service';
import { SignalRService } from '../services/signalr.service';
import { AuthService } from '../services/auth.service';
import { UserMappingService } from '../services/usermapping.service';
import { UserCheckIn } from '../model/userCheckIn';
import { List } from 'immutable';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Roles } from '../common/enums';


@Component({
  selector: 'app-dispatcher',
  templateUrl: './dispatcher.component.html',
  styleUrls: ['./dispatcher.component.css'],
})

export class DispatcherComponent implements OnInit {
  displayedColumns: string[] = ['name', 'buss', 'schedule', 'comment'];
  displayedColumnsLandside: string[] = ['subtype', 'name', 'buss', 'schedule', 'comment'];
  displayedColumnsOther: string[] = ['name', 'schedule', 'comment'];
  displayedColumnsKoor: string[] = ['name', 'skillString', 'schedule', 'comment'];

  public dataSourceLandside = new MatTableDataSource();
  public dataSourceAirside = new MatTableDataSource();
  public dataSourceOther = new MatTableDataSource();
  public dataSourceKoor = new MatTableDataSource();
  public schedules: Schedule[];
  public fullScreen: boolean = false;
  public userCheckIn: UserCheckIn[] = [];
  public time: string;
  public date: string;
  public updated: Date;
  public editRole: boolean = true;
  private initiating: boolean = true;
  private landsideSort: Sort = null;
  private airsideSort: Sort = null;
  private otherSort: Sort = null;
  private koorSort: Sort = null;
  private static readonly lateToWorkThresholdMinutes: number = 5;
  private static readonly lateToWorkCheckIntervalMs: number = 15000;

  public isOpen = false;

  public activitySortOrder = {
    'M1': 1,
    'M2': 2,
    'M3': 3,
    'M4': 4,
    'D1': 5,
    'D2': 6,
    'K1': 7,
    'K2': 8,
    'K3': 9,
    'K4': 10,
    'N1': 11,
    'N2': 12,
    'N3': 13,
    'N4': 14,
    'O1': 15,
    'O2': 16,
    'O5': 17,
    'O5 FM': 18,
    'O5 EM': 19,
    'O3': 20,
    'O4': 21,
    '': 22
  };
  private serviceInformationText: string = "";
  public serviceInformationTextAreaValue: string = "";
  public serviceInformationInputDisabled: boolean;

  constructor(private scheduleService: ScheduleService,
    private settingsService: SettingsService,
    private dispatcherService: DispatcherService,
    private readonly signalRService: SignalRService,
    private auth: AuthService,
    private userMappingService: UserMappingService) { }

  initCheckinSubsription() {
    this.initiating = false;
    this.userMappingService.CheckedInUsers.subscribe((result: List<UserCheckIn>) => {
      this.userCheckIn = result.toArray();
      this.updateCheckInStatus();

    });
  }

  ngOnInit(): void {
    this.landsideSort = { active: "activity", direction: "asc" }; 
    this.airsideSort = { active: "schedule", direction: "asc" };
    this.otherSort = { active: "schedule", direction: "asc" };
    this.koorSort = { active: "schedule", direction: "asc" };

    setInterval(() => {
      this.date = moment().locale('sv').format("D MMM");
      this.time = moment().locale('sv').format("HH:mm:ss");
    }, 1000);

    // load checkedin users
    this.userMappingService.loadAllCheckedInUsers();
 
    setInterval(() => {
      this.checkLateForWorkStatus();
    }, DispatcherComponent.lateToWorkCheckIntervalMs);


    

    this.fetchSchedules();
    setInterval(() => { this.fetchSchedules(); }, 60000);

    this.dispatcherService.getStatus().then((status: DispatchStatus) => {
      if (status) {
        this.updated = status.updatedAt;
        this.serviceInformationTextAreaValue = status.status;
        this.serviceInformationText = status.status;
      }
    });

    this.settingsService.toggleShowNavbar$.subscribe((showNavbar: boolean) => {
      this.fullScreen = !showNavbar;
    });

    this.editRole = this.auth.isInRole(Roles.Planner);
    if (!this.editRole) {      
      this.signalRService.start(this.settingsService.getCurrentAirport());

    }

    this.serviceInformationInputDisabled = !this.editRole;

    this.signalRService.updateDispatchStatus$.subscribe((status: DispatchStatus) => { this.onUpdateMessage(status); });
  }

  toggleModal() {
    const modal = document.getElementById('myModal');
    const myInput = document.getElementById('myInput');
    if (!modal) return;

    if (this.isOpen) {
      // close
      modal.classList.remove('show');
      modal.style.display = 'none';
      modal.setAttribute('aria-hidden', 'true');
    } else {
      // open
      modal.classList.add('show');
      modal.style.display = 'block';
      modal.removeAttribute('aria-hidden');
    }

    this.isOpen = !this.isOpen;
    myInput.focus();
  }

  sortData(sort: Sort, type: string) {
    let scheduleArray = this.schedules.filter(e => e.skill.includes(type));

    scheduleArray = scheduleArray.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'name':
          return compare(a.name, b.name, isAsc);
        case 'activity':
          return compareActivity(a.activityName, b.activityName, this.activitySortOrder, isAsc);
        case 'buss':
          return compare(a.buss, b.buss, isAsc);
        case 'schedule':
          return compare(a.start.getTime(), b.start.getTime(), isAsc);
        case 'comment':
          return compare(a.comment, b.comment, isAsc);
        case 'skill':
          return compare(a.skillString, b.skillString, isAsc);
          
        default:
          return 0;
      }
    });
    switch (type) {
      case 'LAND': {
        this.landsideSort = sort;
        this.dataSourceLandside.data = scheduleArray;
        return;
      }
      case 'AIR': {
        this.airsideSort = sort;
        this.dataSourceAirside.data = scheduleArray;
        return;
      }
      case 'LKOO': {
        this.otherSort = sort;
        this.dataSourceOther.data = scheduleArray;
        return;
      }
      case 'KOOR': {
        this.koorSort = sort;
        this.dataSourceKoor.data = scheduleArray;
        return;
      }
      default:
    }
  }

  private updateSchemas() {

    let tmp = this.schedules.filter(e => e.skill.includes('LAND'));
    this.dataSourceLandside.data = tmp.slice();
    this.dataSourceLandside.data = this.schedules.filter(e => e.skill.includes('LAND'));
    this.dataSourceAirside.data = this.schedules.filter(e => e.skill.includes('AIR'));
    this.dataSourceOther.data = this.schedules.filter(e => e.skill.includes('LKOO'));
    this.dataSourceKoor.data = this.schedules.filter(e => e.skill.includes('KOOR'));
    this.applySorting();
  }

  private applySorting() {
    this.sortData(this.landsideSort, 'LAND');
    this.sortData(this.airsideSort, 'AIR');
    this.sortData(this.otherSort, 'LKOO');
    this.sortData(this.koorSort, 'KOOR');
  }

  private verifyIfStartTimeIsClose(schedule: Schedule): void {
    const diffInSeconds = moment(schedule.start).diff(moment(), 'seconds');
    schedule.lateToWork = diffInSeconds > 0
      && diffInSeconds <= DispatcherComponent.lateToWorkThresholdMinutes * 60;
  }

  private checkLateForWorkStatus(): void {
    if (!this.schedules) return;

    this.schedules.forEach((schedule: Schedule) => {
      if (schedule.checkedin) {
        schedule.lateToWork = false;
        return;
      }
      this.verifyIfStartTimeIsClose(schedule);
    });
  }

  private fetchSchedules() {
    const today = moment().format("YYYY-MM-DD");
    this.scheduleService.getSchedules(today).then((schedules: Schedule[]) => {
      this.schedules = Schedule.ToTypeSafeList(schedules);
      this.updateCheckInStatus();
      if (this.initiating) {
        this.initCheckinSubsription();
      }
    });
  }

  private updateCheckInStatus() {
    if (this.schedules) {
      this.userCheckIn.forEach((user: UserCheckIn) => {
          let currentUserAvailabilites = this.schedules.filter(schedule => schedule.userMappingId === user.usermappingId);
          if (currentUserAvailabilites && currentUserAvailabilites.length > 0) {
            currentUserAvailabilites.forEach((currentUser: Schedule) => {
              if (user.checkOut === null) {
                currentUser.checkedin = true;
              }
              else {
                currentUser.checkedin = false;
              }
            })
          }
      });

      this.checkLateForWorkStatus();
      this.updateSchemas();
    }
  }


  public dirty() {
    return this.serviceInformationText != this.serviceInformationTextAreaValue;
  }

  public update() {
    let value = this.serviceInformationTextAreaValue;
    if (value !== undefined || value !== null) {
      this.dispatcherService.updateMessage(value);
      this.updated = moment().toDate();
    }
    this.toggleModal();
  }

  private onUpdateMessage(status: DispatchStatus) {
    if (this.serviceInformationText !== status.status) {
      this.serviceInformationText = status.status;
      this.serviceInformationTextAreaValue = this.serviceInformationText;
    }
  }

  public maximize() {
    this.settingsService.toggleShowNavbar();
  }

}
export class DispatchStatus {
  status: string;
  id: string;
  updatedAt: Date;
}
function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

function compareActivity(a: number | string, b: number | string, activitySortOrder: any, isAsc: boolean) {

  const sortOrderA = activitySortOrder[a] !== undefined ? activitySortOrder[a] : 100;
  const sortOrderB = activitySortOrder[b] !== undefined ? activitySortOrder[b] : 100;
  return (sortOrderA < sortOrderB ? -1 : 1) * (isAsc ? 1 : -1);
}
